export const FOREVER_TIME = '2999-12-31'
